import VueContextMenuComponent from './VueContextMenu.vue'
const VueContextMenu  = {
	install: function (Vue) {
		Vue.component('VueContextMenu', VueContextMenuComponent)
	}
}
export default VueContextMenu



// WEBPACK FOOTER //
// ./src/main.js